import React, { useState } from 'react';

import { Flex, Image } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';
import { useToast } from 'components/hooks/useToast';

import confetti1 from 'assets/assetsV1/illustrations/deerIllustrations/confetti1.svg';
import confetti2 from 'assets/assetsV1/illustrations/deerIllustrations/confetti2.svg';
import MeshMavenLoading from 'assets/gifs/meshMavenLoading.gif';

import { sendClickedOnBackToRabbitEvent } from 'constants/mixpanelHelper';

import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

import { LaunchDeerModal } from './modals/LaunchDeerModal';
import { launchDeerApp } from './services';

export const DeerBanner = () => {
  const [loading, setLoading] = useState(false);

  const toast = useToast();

  const handleBackToRabbit = async () => {
    try {
      sendClickedOnBackToRabbitEvent({});
      setLoading(true);
      await launchDeerApp({
        operationType: 'DISABLE_PREVIEW',
      });
      window.open('/', '_self');
    } catch (error) {
      toast({
        title: error?.message || 'Error while launching the old ux',
        status: 'error',
      });
      console.log('Error while launching the old ux : ', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Flex
        flexDir="column"
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        zIndex="9999"
        backgroundColor="#EBEFF3"
      >
        <img src={MeshMavenLoading} alt="Logo" width="240px" height="240px" />
        <TextHeader2 bold style={{ marginTop: '10px' }}>
          Launching new user experience
        </TextHeader2>
        <TextBodyMedium>Please wait...</TextBodyMedium>
      </Flex>
    );
  }

  return (
    <Flex
      position="fixed"
      background="#FCFFFC"
      w="100%"
      h="32px"
      alignItems="center"
      justifyContent="space-between"
      zIndex={100}
    >
      <Image w="50px" h="50px" src={confetti1} />
      <Flex alignItems="center">
        <TextBodyMedium bold>This is a preview of the new user experience.</TextBodyMedium>
        <LaunchDeerModal />
        <Button onClick={handleBackToRabbit} variant="text">
          Back to old experience
        </Button>
      </Flex>
      <Image w="50px" h="50px" src={confetti2} />
    </Flex>
  );
};
